import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import SelectController from "../../reusableComponents/SelectController";
import myBackgroundImage from "../../../assets/images/Designer.png";
import baseURL from "./../../authComponents/baseURL/BaseURL"

const HeroScreen = () => {
  const navigate = useNavigate();
  const [formData, setFormData] = useState({
    gender: "female",
    marital_Status: "",
    religion: "Islam",
    occupation: "",
    country: "",
    division: "",
    city: "",
  });
  const [isModalOpen, setIsModalOpen] = useState(false);

  const handleSelectChange = (e) => {
    const { name, value } = e.target;
    setFormData({
      ...formData,
      [name]: value,
    });
  };

  const toggleModal = () => setIsModalOpen(!isModalOpen);

  const convertToUrlParams = (data) => {
    const filteredData = Object.fromEntries(
      Object.entries(data).filter(([_, v]) => v !== "" && v !== null)
    );

    const urlParams = new URLSearchParams(filteredData);
    return urlParams.toString();
  };

  const handleApplyFilters = () => {
    const params = convertToUrlParams(formData);
    const queryString = params ? `?${params}` : "";
    const fetchUrl = `${baseURL}/profiles`;
    navigate(`/all-profiles${queryString}&searchType=local`);

    fetch(`${fetchUrl}${queryString}`)
      .then((response) => {
        if (!response.ok) {
          throw new Error("Network response was not ok");
        }
        return response.json();
      })
      .catch((error) => {
        console.error("Error fetching profiles:", error);
      });
  };

  const selectOptions = [
    {
      label: "I am looking for",
      name: "gender",
      options: [
        { value: "female", label: "Woman" },
        { value: "male", label: "Man" },
      ],
    },
    {
      label: "Marital Status",
      name: "marital_Status",
      options: [
        { value: "", label: "Select Status" },
        { value: "single", label: "Single" },
        // { value: "married", label: "Married" },
        { value: "divorced", label: "Divorced" },
        { value: "separated", label: "Separated" },
        { value: "widow", label: "Widow (Husband Died)" },
        { value: "widower", label: "Widower (Wife Died)" },
      ],
    },
    {
      label: "Religion",
      name: "religion",
      options: [
        { value: "islam", label: "Islam" },
        { value: "christianity", label: "Christianity" },
        { value: "hinduism", label: "Hinduism" },
        { value: "buddhism", label: "Buddhism" },
        { value: "other_religion", label: "Other" },
      ],
    },
    {
      label: "Profession",
      name: "occupation",
      options: [
        { value: "", label: "Select" },
        { value: "Doctor", label: "Doctor" },
        { value: "Engineer", label: "Engineer" },
        { value: "css_officer", label: "CSS Officer" },
        { value: "cyber_security", label: "Cyber Security" },
        { value: "teacher", label: "Teacher" },
        { value: "business_man", label: "Business Man" },
        { value: "armed_forces", label: "Armed Forces" },
        { value: "other", label: "Other" },
      ],
    },
  ];

  return (
    <div
      className="relative w-full min-h-screen bg-cover bg-center md:bg-left-top flex flex-col"
      style={{
        backgroundImage: `url(${myBackgroundImage})`,
      }}
    >
      <div className="text-start p-20 max-md:pt-20 max-md:p-5 flex flex-col mb-8 max-md:mb-0 text-white">
        <h1 className="text-3xl md:text-6xl font-bold">Welcome</h1>
        <p className="text-md md:text-xl md:w-[25%] mt-4 max-md:mt-2">
          Meet your perfect match on our app, the top choice among matrimonial
          sites in Pakistan. Search for your compatible match effortlessly
          across countries.
        </p>
      </div>

      <div className="md:hidden flex justify-center mt-4">
        <button
          onClick={toggleModal}
          className="bg-[#730000] text-white py-2 px-6 rounded-lg hover:bg-[#730000] transition duration-300"
        >
          {isModalOpen ? "Close Filters" : "Find Your Match"}
        </button>
      </div>

      {/* New bottom section for filters */}
      <div className="hidden md:flex justify-center max-lg:flex-wrap mt-20">
        <div className="w-[80%] max-lg:w-[100%] grid grid-cols-5 max-lg:grid-cols-4 gap-3 items-center p-4 rounded-lg">
          {selectOptions.map((selectData) => (
            <SelectController
              key={selectData.name}
              label={selectData.label}
              options={selectData.options}
              value={formData[selectData.name]}
              onChange={handleSelectChange}
              name={selectData.name}
            />
          ))}

          <div className="pt-6 flex">
            <button
              onClick={handleApplyFilters}
              className="w-40 bg-[#730000] text-white py-2 rounded-lg hover:bg-[#730000] transition duration-300"
            >
              See Profiles
            </button>
          </div>
        </div>
      </div>

      {isModalOpen && (
        <div className="fixed inset-0 flex items-center justify-center bg-black overflow-scroll p-8 bg-opacity-50 z-50">
          <div className="bg-white rounded-lg w-full overflow-y-scrol p-2">
            <div className="flex justify-between items-center border-b pb-2 mb-4">
              <h2 className="text-xl font-bold">Search Your Partner</h2>
              <button
                onClick={toggleModal}
                className="text-gray-500 hover:text-[#730000] transition"
              >
                ✕
              </button>
            </div>

            <div className="grid grid-cols-2 text-[10px] gap-1">
              {selectOptions.map((selectData) => (
                <SelectController
                  key={selectData.name}
                  label={selectData.label}
                  options={selectData.options}
                  value={formData[selectData.name]}
                  onChange={handleSelectChange}
                  name={selectData.name}
                />
              ))}
            </div>

            <div className="flex justify-center text-sm mt-6">
              <button
                onClick={() => {
                  handleApplyFilters();
                  toggleModal();
                }}
                className="w-full bg-[#730000] text-white py-2 rounded-lg hover:bg-[#730000] transition duration-300"
              >
                Search Your Partner
              </button>
            </div>
          </div>
        </div>
      )}
    </div>
  );
};

export default HeroScreen;
